import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TransportItem } from '../../../../../models/transport-item.model';
import { OptionsTypeSelector } from '../../../../../models/options-type-selector';
import { TransportFormGroup } from '../../../../../models/forms/TransportFormGroup';
import { HandlingType, LIST_HANDLING_TYPE } from '../../../../../models/handling-type.model';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe, NgIf } from '@angular/common';
import { BarySpecificButtonComponent } from '../../bary-specific-button/bary-specific-button.component';
import { MeasureUnitPipe } from '../../../../pipes/measure-unit.pipe';

@Component({
  selector: 'jhi-bary-transport-item-line',
  templateUrl: './bary-transport-item-line.component.html',
  styleUrls: ['./bary-transport-item-line.component.scss'],
  standalone: true,
  imports: [MDBBootstrapModulesPro, TranslateModule, NgIf, BarySpecificButtonComponent, MeasureUnitPipe, DecimalPipe],
})
export class BaryTransportItemLineComponent {
  @Input() item!: TransportItem;
  @Input() transportFormGroup!: TransportFormGroup;

  @Output() editEvent = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();

  public get handlingTypeItem(): HandlingType {
    return LIST_HANDLING_TYPE[this.item.handlingType] || null;
  }

  public get transportTypology(): OptionsTypeSelector {
    if (this.transportFormGroup.controls.isControlledTemperature.value) {
      return OptionsTypeSelector.TYPE_CONTROLLED_TEMPERATURE;
    }
    if (this.transportFormGroup.controls.isHazardousMaterial.value) {
      return OptionsTypeSelector.TYPE_HAZARDOUS_MATERIAL;
    }
    return OptionsTypeSelector.TYPE_MARCHANDISES_GENERALES;
  }
}
